//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("./is-empty");

export function validateReceiverDetailsInput(data) {
  let validationErrors = {};

  data.erpId = !isEmpty(data.erpId) ? data.erpId : null;
  data.erpName = !isEmpty(data.erpName) ? data.erpName : "";

  if (isNaN(data.erpId)) {
    validationErrors.erpId = "ERP ID should be a number";
  }
  if (!data.erpId) {
    validationErrors.erpId = "ERP ID field is required";
  }

  if (Validator.isEmpty(data.erpName)) {
    validationErrors.erpName = "ERP Name field is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
